import { render, staticRenderFns } from "./OpenAccountStep.vue?vue&type=template&id=0d44c9c2&scoped=true&"
import script from "./OpenAccountStep.vue?vue&type=script&lang=js&"
export * from "./OpenAccountStep.vue?vue&type=script&lang=js&"
import style0 from "./OpenAccountStep.vue?vue&type=style&index=0&id=0d44c9c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d44c9c2",
  null
  
)

export default component.exports